import { TemplatePreviewProps } from './types';
import styles from './TemplatePreview.module.scss';
import { useTranslation } from 'react-i18next';
import React from 'react';

const TemplatePreview = ({ description, resolution, fines }: TemplatePreviewProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.template_preview_container}>
      <div>{description}</div>
      {fines && (
        <div>
          <strong>{t('labels.fines')}:&nbsp;</strong>
          {fines}
        </div>
      )}
      {resolution && (
        <div className={styles.flex_variant}>
          <strong>{t('labels.resolutionCost')}:&nbsp;</strong>
          {resolution}
        </div>
      )}
    </div>
  );
};

export default TemplatePreview;
